module.exports = __webpack_public_path__ + "arrow_icon.png?5f704693c85e78a5919b78dbca195f15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_icon.png
// module id = 7
// module chunks = 0